import styled from '@emotion/styled';
import React from 'react';

export const Divider = styled.div`
  border-bottom: 1px solid #c4c4c4;
  margin: 30px 0;
`;
